import request from '@/utils/request'
const BASE_URL = '/pdd/malls'

export default {
  codelogin(code) {
    return request({
      url: BASE_URL + '/codelogin',
      method: 'post',
      data: { code: code }
    })
  },
  connect(key) {
    return request({
      url: BASE_URL + '/connect/' + key,
      method: 'post',
      headers: { 'UnCheck': 'uncheck' }
    })
  },
  changemall(key) {
    return request({
      url: BASE_URL + '/changemall/' + key,
      method: 'post',
      headers: { 'UnCheck': 'uncheck' }
    })
  },
  getLoginUser() {
    return request({
      url: BASE_URL + '/user',
      method: 'get',
      headers: { 'UnCheck': 'uncheck' }
    })
  },
  getPageCode() {
    return request({
      url: BASE_URL + '/pagecode',
      method: 'get',
    })
  },
  saveSort(data) {
    return request({
      url: BASE_URL + '/savesort',
      method: 'post',
      data,
      headers: { 'UnCheck': 'uncheck' }
    })
  },
  saveUser(data) {
    return request({
      url: BASE_URL + '/saveuser',
      method: 'post',
      data,
      headers: { 'UnCheck': 'uncheck' }
    })
  },
  deleteMall(data) {
    return request({
      url: BASE_URL + '/delete',
      method: 'delete',
      data,
      headers: { 'UnCheck': 'uncheck' }
    })
  },
  msg() {
    return request({
      url: BASE_URL + '/msg',
      method: 'get',
      headers: { 'UnCheck': 'uncheck' }
    })
  },
}